import { useCallback, useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";
import { useDropdown } from "../../hooks/useDropdown";
import { useSelector } from "react-redux";
import { logGenerator } from "../../utility/logGenerator";

const DENIED_MINI_CART_ROUTES = ["/checkout"];

export const useCartTrigger = (props = {}) => {
  const {
    queries: { getItemCountQuery },
  } = props;

  const { cartId } = useSelector((state) => state.cartSlice);

  const location = useLocation();
  const [isHidden, setIsHidden] = useState(() =>
    DENIED_MINI_CART_ROUTES.includes(location.pathname)
  );

  const {
    elementRef: miniCartRef,
    expanded: miniCartIsOpen,
    setExpanded: setMiniCartIsOpen,
    triggerRef: miniCartTriggerRef,
  } = useDropdown();

  useEffect(() => {
    logGenerator("info", `useCartTrigger getItemCountQuery cartId : ${cartId}`);
  }, []);

  const { data, loading } = useQuery(getItemCountQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      cartId,
    },
    skip: !cartId,
    context: { fetchOptions: { method: "GET" } },
  });

  const itemCount = data ? data.cart.total_quantity : 0;

  const handleTriggerClick = useCallback(() => {
    setMiniCartIsOpen((isOpen) => !isOpen);
  }, [setMiniCartIsOpen]);

  useEffect(() => {
    setIsHidden(DENIED_MINI_CART_ROUTES.includes(location.pathname));
  }, [location]);

  return {
    handleTriggerClick,
    itemCount,
    miniCartIsOpen,
    miniCartRef,
    hideCartTrigger: isHidden,
    setMiniCartIsOpen,
    miniCartTriggerRef,
    loading,
  };
};
